require('!!raw-loader!/builds/970483/v2/src/index.html');